import { useEffect, useState } from 'react';

function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hero = document.querySelector('.hero');

    if (!hero || !('IntersectionObserver' in window)) {
      const handleScroll = () => {
        setIsVisible(window.scrollY > window.innerHeight * 0.9);
      };

      window.addEventListener('scroll', handleScroll);
      handleScroll();

      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }

    const updateVisibility = () => {
      setIsVisible(hero.getBoundingClientRect().bottom <= 0);
    };

    const observer = new IntersectionObserver(updateVisibility, {
      threshold: 0,
    });

    observer.observe(hero);
    updateVisibility();

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleContact = () => {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    window.location.href = '/#contact';
  };

  const handleRequest = () => {
    const el = document.getElementById('contact');
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      return;
    }

    window.location.href = '/#contact';
  };

  return (
    <>
      <div className={`floating-cta ${isVisible ? 'show' : ''}`}>
        <div className="floating-cta-inner">
          <button className="cta-main" onClick={handleContact}>
            まずは相談してみる
          </button>
          <button className="cta-sub" onClick={handleRequest}>
            資料請求
          </button>
        </div>
      </div>

      <aside className={`desktop-floating-cta ${isVisible ? 'show' : ''}`}>
        <p className="desktop-floating-cta__label">CONTACT</p>
        <button className="desktop-floating-cta__button" onClick={handleContact}>
          相談する <span aria-hidden="true">→</span>
        </button>
      </aside>
    </>
  );
}

export default FloatingCTA;
